import React from "react";

const Context = {
  markDownText: "",
  setMarkDownText: () => {},
};

export default React.createContext(Context);
